import { combineReducers } from "@reduxjs/toolkit";
import packageCarsReducer, {
  type PackageCarsState,
} from "../../../pages/Packages/features/cars/store/slice";
import packagesBaseReducer, { type PackageBaseState } from "./packages";
import packageFlightsReducer, {
  type PackageFlightsState,
} from "./packagesFlights";
import packageHotelReducer, { type PackageHotelState } from "./packagesHotels";
import packagesSearchReducer, {
  type PackageSearchState,
} from "./packagesSearch";

export type PackageState = {
  packages: {
    base: PackageBaseState;
    search: PackageSearchState;
    hotel: PackageHotelState;
    flights: PackageFlightsState;
    cars: PackageCarsState;
  };
};

export const packagesReducer = combineReducers({
  base: packagesBaseReducer,
  search: packagesSearchReducer,
  hotel: packageHotelReducer,
  flights: packageFlightsReducer,
  cars: packageCarsReducer,
});
